import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
// Temporary products only available for delivery free in store
var AVAILABLE_FOR_LGM = ['129661', '139532', '142025', '155848', '164512', '174871', '186576', '198093', '198102', '198103', '198104'];
export default AVAILABLE_FOR_LGM;